import loadedHandler from "@/scripts/helpers/loaded.js";

const events = [
    'keydown',
    'touchstart',
    'touchmove',
    'mouseover',
];

(() => {
    let loaded = false;
    let lazyScripts = {
        insertBefore: [],
        appendChild: [],
    };

    window['immediateScripts'] = typeof window['immediateScripts'] === 'function' ? window['immediateScripts'] : function (node) {
        try {
            if (loaded) {
                return true;
            }

            if (!(node instanceof Element)) {
                return true;
            }

            if (!!node?.matches('meta')) {
                return true;
            }

            if ([
                '#PBarNextFrameWrapper',
                '#PBarNextFrameWrapper',
                '#OnlineStorePreviewBarNextData',
                '#__st',
                '#shop-js-analytics',
                '[data-source-attribution]',
                '#web-pixels-manager-setup',
                '#shopify-features',
            ]?.map((selector) => {
                return !!node?.matches(selector);
            })?.includes(true)) {
                return false;
            }

            const boostEager = window.__template === 'collection' || window.__template === 'search';
            const boostSrcFragments = ['cdn.boostcommerce.io', 'boost-'];
            const boostInnerFragments = ['boostWidgetIntegration', 'boost', 'Boost'];

            // On the cart page Easify must init AFTER Route, otherwise Route captures
            // Easify's checkout-button clone and later dispatches to it once Easify has
            // replaced it -> detached node -> ep() null crash. Elsewhere keep it eager.
            const easifyEager = window.__template !== 'cart';
            const easifySrcFragments = easifyEager
                ? ['easify-product-options', 'product-options-', 'tpo-class', 'tpo-global']
                : [];

            switch (node?.tagName?.toLowerCase()) {
                case "script": {
                    const src = node?.src || '';
                    const html = node?.innerHTML || '';
                    if (boostEager && (boostSrcFragments.some((f) => src.includes(f)) || boostInnerFragments.some((f) => html.includes(f)))) {
                        return true;
                    }
                    if (node?.id === 'web-pixels-manager-setup') return true;
                    return !![
                        !![
                            'shop-js/client.js',
                            '/checkouts/internal/preloads.js',
                            '/cdn/wpm/',
                            'shopify-perf-kit-',
                            'preview_bar_injector',
                            'consentmo',
                            'gdpr-backpack',
                            ...easifySrcFragments,
                        ]?.map((fragment) => {
                            return !!node?.src?.includes(fragment);
                        })?.includes(true),
                        !![
                            'application/ld+json',
                            'application/json',
                        ]?.includes(node?.type?.toLowerCase()),
                        !![
                            'function asyncLoad()',
                            'window.performance',
                            'window.ShopifyPaypalV4VisibilityTracking',
                            'window.ShopifyAnalytics',
                            'o.Shopify=o.Shopify',
                            'session_token_from_headers',
                            'Shopify.shop =',
                            '__st',
                            'Shopify.currency',
                            'loadFeatures',
                            'TPOConfigs',
                            'consentmo',
                        ]?.map((fragment) => {
                            return !!node?.innerHTML?.includes(fragment);
                        })?.includes(true),
                    ]?.includes(true);
                }
                case "link": {
                    const href = node?.href || '';
                    if (boostEager && boostSrcFragments.some((f) => href.includes(f))) {
                        return true;
                    }
                    return !![
                        !![
                            'easify-product-options',
                            'product-options-',
                            'https://shop.app',
                        ]?.map((fragment) => {
                            return !!node?.href?.includes(fragment);
                        })?.includes(true),
                        !![
                            'link[rel="modulepreload"]',
                            'link[rel="dns-prefetch preconnect"]',
                            'link[rel="dns-prefetch"]',
                        ]?.map((fragment) => {
                            return !!node?.matches(fragment);
                        })?.includes(true),
                    ]?.includes(true);
                }
                case "style": {
                    return true;
                }
            }
        } catch (error) {
            console.log(error);
        }

        return true;
    };

    ((appendChild) => {
        window.Element.prototype.appendChild = function (node, ...args) {
            if (!node) {
                return null;
            }

            if (!(node instanceof Element)) {
                return appendChild.call(this, node, ...args);
            }

            if (!node?.matches('script, style, link')) {
                return appendChild.call(this, node, ...args);
            }

            if (!!window.immediateScripts(node)) {
                try {
                    return appendChild.call(this, node, ...args);
                } catch (error) {
                    console.log({
                        error,
                    });

                    console.error(`Error while executing`, parent, 'with args', args, error);
                }

                return node;
            }

            node.async = false;
            node.defer = true;

            lazyScripts.appendChild.push([this, node]);

            return node;
        };
    })(window.Element.prototype.appendChild);

    ((insertBefore) => {
        window.Element.prototype.insertBefore = function (node, ...args) {
            if (!node) {
                return null;
            }

            if (!(node instanceof Element)) {
                return insertBefore.call(this, node, ...args);
            }

            if (!node?.matches('script, style, link')) {
                return insertBefore.call(this, node, ...args);
            }

            if (window.immediateScripts(node)) {
                try {
                    return insertBefore.call(this, node, ...args);
                } catch (error) {
                    console.log(error, node, ...args);

                    console.error(`Error while executing`, parent, 'with args', args, error);
                }

                return node;
            }

            node.async = false;
            node.defer = true;

            lazyScripts.insertBefore.push([this, node, ...args]);

            return node;
        };
    })(window.Element.prototype.insertBefore);

    const loader = () => {
        if (loaded) {
            return;
        }

        loaded = true;

        Object.keys(lazyScripts).forEach((position) => {
            const scripts = lazyScripts[position];
            if (!scripts) {
                return;
            }

            if (!scripts?.length) {
                return;
            }

            scripts.forEach(([parent, node, ...args]) => {
                if (!parent) {
                    return;
                }

                if (!node) {
                    return;
                }

                try {
                    parent.appendChild(node, ...args);
                } catch(error) {
                    console.error(`Error while executing ${position} on`, parent, 'with args', args, error);
                }
            });
        });
    };

    loadedHandler(() => {
        window.addEventListener('scroll', loader, {
            once: true,
            passive: true,
        });

        events?.forEach((eventName) => {
            document.addEventListener(eventName, loader, {
                once: true,
                passive: true,
            });
        });
    });
})();
